import {Footer} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import ComponentConfig, {
  SaveButton,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import SizeSection from 'organization/Event/WidgetConfig/ButtonStylesConfig/SizeSection'
import BorderSection from 'organization/Event/WidgetConfig/ButtonStylesConfig/BorderSection'
import TypographySection from 'organization/Event/WidgetConfig/ButtonStylesConfig/TypographySection'
import BackgroundSection from 'organization/Event/WidgetConfig/ButtonStylesConfig/BackgroundSection'
import {ButtonStyles, Widget} from 'Event/Widget/template'
import {renderButton} from 'Event/Widget/script/elements/button'
import {
  ConfigureButton,
  PreviewHolder,
} from 'organization/Event/WidgetConfig/CalendarStylesConfig'

export default function ButtonStylesConfig(props: {
  styles: ButtonStyles
  onChange: (updatedStyles: ButtonStyles) => void
  widget: Widget
}) {
  const {styles, onChange, widget} = props

  const [showing, setShowing] = useState(false)
  const {control, handleSubmit, watch, formState, reset} = useForm({
    defaultValues: styles || undefined,
  })

  const onClose = () => {
    setShowing(false)
  }

  const saveChanges = (data: ButtonStyles) => {
    onChange(data)
    reset(data)
    onClose()
  }

  const ref = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      renderButton(
        ref.current,
        {
          ...widget,
          template: {
            ...widget.template,
            button: {
              ...widget.template.button,
              styles: watch(),
            },
          },
        },
        '',
      )
    }
  }, [widget, ref, watch])

  return (
    <>
      <ConfigureButton variant="outlined" onClick={() => setShowing(true)}>
        {'Button Configuration'}
      </ConfigureButton>

      <PreviewHolder>
        <div ref={ref}></div>
      </PreviewHolder>

      <ComponentConfig
        showing={showing}
        onClose={onClose}
        title={'Button Configuration'}
        onSubmit={handleSubmit(saveChanges)}
        hasChanges={formState.isDirty}
      >
        <StylingPanel>
          <TypographySection
            button={styles}
            control={control}
            storageKey="cf"
          />
          <BackgroundSection
            button={styles}
            control={control}
            storageKey="cf"
          />
          <SizeSection button={styles} control={control} storageKey="cf" />
          <BorderSection button={styles} control={control} storageKey="cf" />
        </StylingPanel>
        <Footer>
          <SaveButton type="submit" />
        </Footer>
      </ComponentConfig>
    </>
  )
}
